import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSmartModalService } from 'ngx-smart-modal';

import { CacheService } from 'app/infrastructure/services/cache.service';
import {
  DesignerContextType,
  DesignerCachableOutput,
} from 'app/private/sxfdesigner/types/designer-context-type';
import { SxInternalStateDesignerService } from 'app/private/sxfdesigner/services/internal-state-designer-service';
import { CompleteDesignerContext } from '../../main/completeContext';
import { NonTransactionalFlowService } from 'app/infrastructure/services/non-transactional-flow.service';

@Component({
  selector: 'sx-create-flow-modal',
  templateUrl: './create-flow-modal.component.html',
})
export class SxCreateFlowModalComponent {
  // The name of the new page for the page modals
  flowDescription: string;
  // Designer Context
  @Input()
  designerContext: DesignerContextType;
  // Application Context
  @Input()
  completeContext: CompleteDesignerContext;

  @Output()
  saveDesigner: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private ngxSmartModalService: NgxSmartModalService,
    private router: Router,
    private cacheService: CacheService,
    private nonTransactionalSrv: NonTransactionalFlowService
  ) {}

  // this is triggered to create a new flow page if needed
  createNewFlow() {
    this.saveDesigner.emit(false);
    this.cacheService.removeDesignerOutputs();
    this.ngxSmartModalService.getModal('createFlowModal').close();
    this.nonTransactionalSrv
      .createNonTransactionalFlow({ Description: this.flowDescription })
      .subscribe((flowId) => {
        this.router.navigateByUrl(`soc/nontransactionalflows/${flowId}`);
      });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/modals/create-flow/create-flow-modal.component.ts